import { Controller } from "@hotwired/stimulus"

// Allows click+drag panning of an infinite canvas
export default class extends Controller {
  static targets = ["emptyMessage", "contentMessage", "card"]
  static values = {
    hasAction: Boolean
  }

  connect() {
    this.canvas = this.element
    this.canvas.addEventListener("mousedown", this.mouseDown)
    window.addEventListener("mousemove", this.mouseMove)
    window.addEventListener("mouseup", this.mouseUp)

    if (this.hasActionValue) {
      this.canvas.style.left = "0"
    }
  }

  // Mouse Events
  mouseDown(e) {
    this.isDragging = true
    this.startX = e.clientX
    this.startY = e.clientY
    this.scrollLeft = this.canvas.scrollLeft
    this.scrollTop = this.canvas.scrollTop
    // this.canvas.style.cursor = "grabbing"
  }

  mouseMove(e) {
    if (!this.isDragging) return
    const x = e.clientX - this.startX
    const y = e.clientY - this.startY
    this.canvas.scrollLeft = this.scrollLeft - x
    this.canvas.scrollTop = this.scrollTop - y
  }

  mouseUp() {
    this.isDragging = false
    // this.canvas.style.cursor = "grab"
  }

  // Stimulus hooks
  initialize() {
    this.mouseMove = this.mouseMove.bind(this)
    this.mouseDown = this.mouseDown.bind(this)
    this.mouseUp = this.mouseUp.bind(this)
  }

  disconnect() {
    this.canvas.removeEventListener("mousedown", this.mouseDown)
    window.removeEventListener("mousemove", this.mouseMove)
    window.removeEventListener("mouseup", this.mouseUp)
  }

  emitTriggerSidebarEvent(event) {
    const triggerType = event.currentTarget.dataset.triggerType
  
    if (!triggerType) return


    this.selectCard(event.currentTarget)
    this.setMessageOffsets()

    window.dispatchEvent(
      new CustomEvent("openTriggerSidebar", {
        detail: { triggerType }
      })
    )
  }

  emitActionSidebarEvent(event) {
    const el = event.currentTarget
  
    const actionType = el.dataset.actionType
    const actionId = el.dataset.actionId
    const flagTypeId = el.dataset.flagTypeId
    const description = el.dataset.description
  
    if (!actionType || !actionId) return

    this.selectCard(el)
    this.setMessageOffsets()
  
    window.dispatchEvent(new CustomEvent("openActionSidebar", {
      detail: {
        actionType,
        actionId,
        flagTypeId,
        description
      }
    }))
  }

  emitNewActionSidebarEvent(event) {
    this.selectCard(event.currentTarget)
    this.setMessageOffsets()
    window.dispatchEvent(new CustomEvent("openNewActionSidebar"))
  }

  selectCard(cardElement) {
    this.cardTargets.forEach(card => card.classList.remove("workflow-card-selected"))
    cardElement.classList.add("workflow-card-selected")
  }

  setMessageOffsets() {

    const smallScreen = window.matchMedia("(max-width: 600px)").matches;
    const sidebarWidth = smallScreen ? 190 : 235;

    if (smallScreen) {
      this.canvas.style.left = `${sidebarWidth}px`;
    }

    const offset = `calc(50% - ${sidebarWidth} / 2)`;
  
    if (this.hasEmptyMessageTarget) {
      this.emptyMessageTarget.style.left = offset
    }
  
    if (this.hasContentMessageTarget) {
      this.contentMessageTarget.style.left = offset
    }
  }  
  
}

